import { Typography } from '@mui/material';
import { dateFormatter } from '../../helper/dateFormater';

const DateCell = ({ date }) => {
	return (
		<Typography sx={{ fontWeight: 'bold', fontSize: '0.875rem' }}>
			{dateFormatter(date)}
		</Typography>
	);
};

export default DateCell;
